(() => {
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
  const fallbackLabels = {awgSelect:'AWG selection', ampsNeeded:'Required current (A)', unitCustom:'Custom unit', customVoltage:'Custom voltage (V)', revValue:'Resistance', revUnit:'Resistance unit', revTolerance:'Tolerance', revBands:'Band count', smdInput:'SMD code', 'sp-r1':'Resistor 1', 'sp-r2':'Resistor 2', 'sp-r3':'Resistor 3', 'sp-unit':'Resistor unit', 'unit-V':'Voltage unit', 'unit-I':'Current unit', 'unit-R':'Resistance unit', 'unit-P':'Power unit'};
  document.querySelectorAll('[data-koeed-workspace]').forEach(root => {
    const contact = root.querySelector('[data-workspace-inquiry]');
    if (!contact || contact.dataset.ready) return;
    contact.dataset.ready = 'true';
    const visible = el => !!el && !el.closest('[hidden]') && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    const text = id => clean(root.querySelector('#' + id)?.textContent);
    const type = root.dataset.koeedWorkspace;
    function message() {
      const lines = [clean(root.querySelector('h1')?.textContent) + ' inquiry'];
      root.querySelectorAll('.workspace-main input, .workspace-main select, .workspace-main textarea').forEach(el => {
        if (!visible(el) || el.type === 'range' || el.type === 'hidden' || el.type === 'button') return;
        const label = root.querySelector('label[for="' + el.id + '"]');
        const name = clean(label?.textContent || el.getAttribute('aria-label') || fallbackLabels[el.id] || el.id);
        const value = el.tagName === 'SELECT' ? el.selectedOptions[0]?.textContent : el.value;
        lines.push(name + ': ' + (clean(value) || '(not entered)'));
      });
      // Only current visible modes/units are included; inactive tabs never leak into a message.
      const selections = [...root.querySelectorAll('.workspace-main button.active, .workspace-main button.active-preset, .workspace-main button.selected')].filter(visible).map(el => clean(el.textContent));
      if (selections.length) lines.push('Selected options: ' + selections.join(' / '));
      if (type === 'ip-rating-lookup') lines.push('Selected rating: ' + text('resultIpCode'));
      if (type === 'resistor-color-calc' && visible(root.querySelector('#tab-color-to-value'))) lines.push('Selected bands: ' + text('resistanceDetail'));
      if (type === '4-20ma-converter') lines.push('Status: ' + text('faultBanner'));
      if (type === 'plc-hex-converter') {
        lines.push('Status: ' + (text('hexStatus') || 'Conversion available'));
        for (const order of ['ABCD','CDAB','DCBA','BADC']) lines.push(order + ': ' + text('hex' + order) + ' / ' + text('val' + order));
      }
      if (type === 'modbus-calculator') {
        if (visible(root.querySelector('#tab-calc'))) lines.push('CRC-16 (low-high): ' + text('crcResult'), 'LRC: ' + text('lrcResult'), 'Status: ' + text('inputMsg'));
        if (visible(root.querySelector('#tab-build'))) lines.push('RTU frame: ' + text('frameOutput'), 'Status: ' + text('builderMsg'));
      }
      lines.push('Page: ' + contact.dataset.pageUrl);
      return lines.join('\n');
    }
    function update() {
      const body = encodeURIComponent(message());
      contact.querySelector('[data-inquiry-email]').setAttribute('href', 'mailto:' + contact.dataset.email + '?subject=' + encodeURIComponent('Industrial parts inquiry') + '&body=' + body);
      contact.querySelector('[data-inquiry-whatsapp]').setAttribute('href', 'https://wa.me/8613533898924?text=' + body);
    }
    let frame;
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
    ['input','change','click'].forEach(event => root.addEventListener(event, schedule));
    // Refresh synchronously for normal, keyboard and middle-click navigation.
    ['click','auxclick','contextmenu','focusin'].forEach(event => contact.addEventListener(event, update));
    const copy = contact.querySelector('[data-inquiry-copy]');
    copy.hidden = false;
    copy.addEventListener('click', async () => {
      const status = contact.querySelector('[data-inquiry-copy-status]');
      try { await navigator.clipboard.writeText(message()); status.textContent = 'Copied.'; }
      catch { status.textContent = 'Copy unavailable. Use Email or WhatsApp.'; }
    });
    update();
    document.addEventListener('DOMContentLoaded', schedule, {once:true});
  });
})();
